import { gql } from '@apollo/client'

import { ASSISTANT_FIELDS_FRAGMENT } from './fragments'

export const GET_ASSISTANT_TOOLS = gql`
  query GetAssistantTools($workspaceId: String!) {
    assistantTools(workspaceId: $workspaceId) {
      id
      label
      description
      allowed {
        templates
        temperature
        models
      }
      templateType
      async
    }
  }
`

export const GET_ALL_TOOLS = gql`
  query GetAllTools {
    registryTools {
      id
      label
      description
      allowed {
        templates
        temperature
        models
      }
      templateType
      async
    }
  }
`

export const GET_USER_ASSISTANTS = gql`
  query GetUserAssistants($workspaceId: String!) {
    userAssistants(workspaceId: $workspaceId) {
      ...AssistantFields
    }
  }
  ${ASSISTANT_FIELDS_FRAGMENT}
`
export const GET_WORKSPACE_ASSISTANTS = gql`
  query GetWorkspaceAssistants($workspaceId: String!) {
    workspaceAssistants(workspaceId: $workspaceId) {
      ...AssistantFields
    }
  }
  ${ASSISTANT_FIELDS_FRAGMENT}
`

export const GET_USER_ASSISTANT = gql`
  query GetUserAssistant($assistantId: String!, $workspaceId: String!) {
    userAssistant(assistantId: $assistantId, workspaceId: $workspaceId) {
      ...AssistantFields
    }
  }
  ${ASSISTANT_FIELDS_FRAGMENT}
`

export const GET_ASSISTANT_TIERS = gql`
  query GetAssistantTiers {
    assistantTiers {
      id
      name
      description
      tools
      models
      events
      schedules
      stripeProductId
      current
    }
  }
`

export const GET_ASSISTANT_ACTIONS = gql`
  query GetAssistantActions($assistantId: String!, $workspaceId: String!) {
    actionsForAssistant(assistantId: $assistantId, workspaceId: $workspaceId) {
      id
      title
      description
      owner {
        id
      }
      timeframe {
        dueDate
        reminderDate
      }
      status {
        label
      }
      priority
      type
    }
  }
`

export const GET_ASSISTANT_MODELS = gql`
  query GetAssistantModels {
    assistantModels
  }
`

export const GENERATE_PROMPTS_FOR_OBJECT = gql`
  query GeneratePromptsForObject(
    $objectType: String!
    $objectId: String!
    $workspaceId: String!
    $assistantId: String
  ) {
    generatePromptsForObject(
      objectType: $objectType
      objectId: $objectId
      workspaceId: $workspaceId
      assistantId: $assistantId
    ) {
      questions
      keyObservation
    }
  }
`
